exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".project-form-item[data-v-03e7d25a] .el-form-item__error{position:absolute;top:0.01042rem;left:0.05208rem}.suffix[data-v-03e7d25a]{margin-top:-0.07813rem;padding:0 0.02083rem;height:0.15625rem;line-height:0.15625rem;color:#a6a6a6;position:absolute;top:50%;right:0;z-index:10}.form-checkbox-group[data-v-03e7d25a] .el-form-item__content{display:unset !important}\n", ""]);

// exports
